
angular.module('gallery').controller('galleryCtrl', ['galleryAnalytics', function (galleryAnalytics) { }]);




